export const T = {
  en_GB: {
    title: "Members",
    description: "The persons this group consists of (couples / joint investors).",
    addMember: "Add Member",
    editMember: "Edit Member",
    noMembers: "No members yet. Add the persons this group consists of.",
    dialogDescription: "Link an existing person client or enter the member's details.",
    editDialogDescription: "Update the member's details.",
    linkExisting: "Link existing client",
    searchClients: "Search person clients…",
    noMatches: "No matching person clients.",
    linkedTo: "Linked client",
    linkedNoAccess: "You do not have access to the linked client",
    notLinked: "Not linked",
    unlink: "Unlink",
    undoUnlink: "Keep link",
    unlinkNote:
      "Unlinking keeps this member (same member, answers kept), but their personal link is withdrawn. After linking again, a new one must be issued.",
    unlinkPending:
      "Will be unlinked when you save. The member and their answers are kept, but their personal link is withdrawn. After linking again, a new one must be issued.",
    name: "Name",
    ssn: "SSN",
    dateOfBirth: "Date of birth",
    email: "Email",
    phone: "Phone",
    representative: "Representative",
    representativeHelp:
      "This member represents the group in advisory sessions and is shown on the Representative tab, unless an external representative is registered there. Several members may be marked: with one, that member answers for the group; with two or more, every marked member answers knowledge and experience for themselves.",
    representativeCap: (max: number) =>
      `A group can have at most ${max} members marked as representative.`,
    representativeBlocked:
      "An external representative is registered on the Representative tab. Remove it there before marking a member instead.",
    authorityBasis: "Authority basis",
    basisLabels: {
      signatory: "Signatory rights",
      board_resolution: "Board resolution",
      poa: "Power of attorney",
      fremtidsfullmakt: "Future POA (fremtidsfullmakt)",
      vergemal: "Guardianship (vergemål)",
    } as Record<string, string>,
    selectBasis: "Select basis…",
    nameRequired: "Name is required",
    save: "Save",
    cancel: "Cancel",
    deleteMember: "Remove Member",
    deleteConfirmation: (name: string) => `Remove "${name}" from the group?`,
    delete: "Remove",
    failedToSave: "Failed to save member",
  },
  nb_NO: {
    title: "Medlemmer",
    description: "Personene denne gruppen består av (par / felles investorer).",
    addMember: "Legg til medlem",
    editMember: "Rediger medlem",
    noMembers: "Ingen medlemmer ennå. Legg til personene gruppen består av.",
    dialogDescription: "Koble en eksisterende personkunde eller skriv inn medlemmets detaljer.",
    editDialogDescription: "Oppdater medlemmets detaljer.",
    linkExisting: "Koble eksisterende kunde",
    searchClients: "Søk etter personkunder…",
    noMatches: "Ingen personkunder samsvarer.",
    linkedTo: "Koblet kunde",
    linkedNoAccess: "Du har ikke tilgang til den koblede kunden",
    notLinked: "Ikke koblet",
    unlink: "Fjern kobling",
    undoUnlink: "Behold kobling",
    unlinkNote:
      "Når koblingen fjernes, beholdes medlemmet (samme medlem, svarene beholdes), men den personlige lenken trekkes tilbake. Etter ny kobling må en ny lenke utstedes.",
    unlinkPending:
      "Koblingen fjernes når du lagrer. Medlemmet og svarene beholdes, men den personlige lenken trekkes tilbake. Etter ny kobling må en ny lenke utstedes.",
    name: "Navn",
    ssn: "Fødselsnummer",
    dateOfBirth: "Fødselsdato",
    email: "E-post",
    phone: "Telefon",
    representative: "Representant",
    representativeHelp:
      "Dette medlemmet representerer gruppen i rådgivningssesjoner og vises under Representant-fanen, med mindre en ekstern representant er registrert der. Flere medlemmer kan markeres: med ett svarer dette medlemmet for gruppen, med to eller flere svarer hvert markerte medlem på kunnskap og erfaring for seg selv.",
    representativeCap: (max: number) =>
      `En gruppe kan ha høyst ${max} medlemmer markert som representant.`,
    representativeBlocked:
      "En ekstern representant er registrert under Representant-fanen. Fjern den der før du markerer et medlem i stedet.",
    authorityBasis: "Fullmaktsgrunnlag",
    basisLabels: {
      signatory: "Signaturrett",
      board_resolution: "Styrevedtak",
      poa: "Fullmakt",
      fremtidsfullmakt: "Fremtidsfullmakt",
      vergemal: "Vergemål",
    } as Record<string, string>,
    selectBasis: "Velg grunnlag…",
    nameRequired: "Navn er påkrevd",
    save: "Lagre",
    cancel: "Avbryt",
    deleteMember: "Fjern medlem",
    deleteConfirmation: (name: string) => `Fjerne "${name}" fra gruppen?`,
    delete: "Fjern",
    failedToSave: "Kunne ikke lagre medlem",
  },
} as const;
